angular.module('wco.directives.packagingDuplicate', [])
    .controller('WcoPackagingDuplicateController', ['$scope','$uibModal', '$log', function($scope, $uibModal, $log) {
        $scope.open = function() {
            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'angular/directives/packagingDuplicateModal.html',
                controller: 'WcoPackagingDuplicateModalController',
                size: 'lg',
            });

            modalInstance.result.then(function (message) {
                $scope.$emit($scope.eventTitle, message);
            }, function () {
                // user clicked abor
            });
        };
    }])
    .directive('wcoPackagingDuplicate', ['$timeout', function($timeout) {
        return {
            controller: 'WcoPackagingDuplicateController',
            controllerAs: 'packingDuplicate',
            templateUrl: function(element, attrs){
                return attrs.templateUrl || 'angular/directives/packagingDuplicate.html';
            },
            scope:{
                eventTitle: '='
            },
            transclude: true,
            replace: true
        };
    }])
    .controller('WcoPackagingDuplicateModalController',  ['$scope','$uibModalInstance', 'packingDaisyService', function ($scope, $uibModalInstance, packingDaisyService) {
        $scope.numberOfDuplicates = 1;

        $scope.confirmSelection = function () {
            $uibModalInstance.close($scope.numberOfDuplicates);
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]);